import { render, staticRenderFns } from "./productItems.vue?vue&type=template&id=78364104&scoped=true"
import script from "./productItems.vue?vue&type=script&lang=js"
export * from "./productItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78364104",
  null
  
)

export default component.exports